import React from "react";
import { accommodations } from "../data/mockData"; // use "../data/metadata" if that is your project's location

const formatPrice = (price) => new Intl.NumberFormat("en-IN").format(price);

export default function Accommodation() {
  return (
    <div className="bg-white min-h-screen">
      <section className="bg-gradient-to-r bg-blue-950 py-16 text-center">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-white mb-4 tracking-wider">
          ACCOMMODATION
        </h1>
        <div className="w-32 sm:w-48 h-1 bg-blue-600 mx-auto"></div>
      </section>

      <section className="mx-auto max-w-7xl px-5 py-10 sm:px-8 lg:py-14">
        <div className="hidden overflow-x-auto rounded-2xl border border-slate-200 bg-white shadow-sm lg:block">
          <table className="min-w-full text-left text-sm">
            <thead className="bg-[#172554] text-white">
              <tr>
                {[
                  "S.No.",
                  "Hotel",
                  "Address",
                  "Website / Email",
                  "Contact No.",
                  "Deluxe Room",
                  "Executive Room",
                ].map((heading) => (
                  <th
                    key={heading}
                    className="whitespace-nowrap px-5 py-4 font-bold"
                  >
                    {heading}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {accommodations.map((hotel) => (
                <tr key={hotel.id} className="hover:bg-blue-50/50">
                  <td className="px-5 py-5 font-semibold">{hotel.id}</td>
                  <td className="px-5 py-5 font-bold text-[#172554]">
                    {hotel.name}
                  </td>
                  <td className="px-5 py-5 text-slate-600">{hotel.address}</td>
                  <td className="px-5 py-5">
                    <a
                      className="text-blue-700 underline"
                      href={hotel.website}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {hotel.websiteLabel}
                    </a>
                  </td>
                  <td className="px-5 py-5">
                    <a
                      className="font-semibold text-slate-700"
                      href={`tel:${hotel.phone}`}
                    >
                      {hotel.phone}
                    </a>
                  </td>
                  <td className="px-5 py-5 text-center font-bold">
                    ₹{formatPrice(hotel.deluxe)}
                  </td>
                  <td className="px-5 py-5 text-center font-bold">
                    ₹{formatPrice(hotel.executive)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="grid gap-5 lg:hidden sm:grid-cols-2">
          {accommodations.map((hotel) => (
            <article
              key={hotel.id}
              className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm"
            >
              <p className="text-xs font-bold uppercase tracking-widest text-blue-600">
                Accommodation {String(hotel.id).padStart(2, "0")}
              </p>
              <h2 className="mt-2 text-xl font-bold text-[#172554]">
                {hotel.name}
              </h2>
              <p className="mt-3 text-sm leading-6 text-slate-600">
                {hotel.address}
              </p>
              <a
                className="mt-4 block break-all text-sm font-semibold text-blue-700 underline"
                href={hotel.website}
                target="_blank"
                rel="noreferrer"
              >
                {hotel.websiteLabel}
              </a>
              <a
                className="mt-3 block font-semibold text-slate-700"
                href={`tel:${hotel.phone}`}
              >
                {hotel.phone}
              </a>
              <div className="mt-5 grid grid-cols-2 gap-3 text-center">
                <div className="rounded-xl bg-blue-50 p-3">
                  <p className="text-xs font-semibold text-blue-700">Deluxe</p>
                  <p className="mt-1 font-extrabold">
                    ₹{formatPrice(hotel.deluxe)}
                  </p>
                </div>
                <div className="rounded-xl bg-emerald-50 p-3">
                  <p className="text-xs font-semibold text-emerald-700">
                    Executive
                  </p>
                  <p className="mt-1 font-extrabold">
                    ₹{formatPrice(hotel.executive)}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
